import { newToast } from '../components';
import { useAppDispatch } from '../contexts/hooks';
import { removeAttachment, setAttachmentFromServer } from '../contexts/slices/orders';
import useApi from '../utils/axios-pettitions'; // <- tu helper con runApi + runApiFormData

export const useApiStorage = () => {
  const { runApiFormData, runApi } = useApi();
  const dispatch = useAppDispatch();

  const Upload = async (formData: FormData) => {
    const res = await runApiFormData('Storage/upload', formData);

    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 3);
    } else {
      newToast('SUCCESS', res.message, 3);
      dispatch(setAttachmentFromServer(res.data));
    }
  };

  const Delete = async (id: number) => {
    const res = await runApi('Storage/Delete', 'POST', { id }, null);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 3);
    } else {
      newToast('SUCCESS', res.message, 3);
      dispatch(removeAttachment(id));
    }
  };

  const GetFile = async (id: number) => {
    const res = await runApi('Storage/getFile', 'GET', { id }, null);
    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 3);
      return null;
    } else {      
      return res.data;      
    }
  };

  return {
    Upload,
    Delete,
    GetFile
  };
};
